export const getChateauChalonData = () => ({
  name: "Château-Chalon",
  region: "Jura",
  country: "France",
  description: "Château-Chalon est une appellation prestigieuse du Jura, dédiée exclusivement au vin jaune. Cette sous-région produit l'un des vins les plus uniques au monde, élevé selon des méthodes ancestrales sous voile de levures pendant 6 ans minimum. Le vin jaune de Château-Chalon est considéré comme l'expression ultime de cette tradition viticole jurassienne.",
  type: "subregion",
  area: "50 hectares",
  production: "50,000 bouteilles par an",
  climate: "Semi-continental avec influences montagneuses",
  soil: "Marnes bleues du Jurassique",
  characteristics: {
    "Terroir": "Marnes bleues du Jurassique, exposition sud",
    "Climat": "Semi-continental avec étés chauds et hivers rigoureux",
    "Altitude": "300-450 mètres",
    "Exposition": "Sud dominante, protégée des vents froids"
  },
  grapeVarieties: {
    "Blancs": {
      "Savagnin": {
        description: "Cépage unique et emblématique du Jura, base exclusive du vin jaune",
        characteristics: "Acidité élevée, potentiel oxydatif exceptionnel, arômes complexes",
        wineStyle: "Vin jaune oxydatif, vin blanc sec",
        viticulture: "Rendements limités, vendanges tardives, raisins surmûris"
      }
    }
  },
  wineStyles: {
    "Vin Jaune": "Vin blanc oxydatif unique au monde, élevé sous voile de levures pendant 6 ans minimum dans des fûts de chêne non ouillés. Notes de noix, curry, épices, amandes, fruits secs. Très longue garde (50+ ans).",
    "Vin Blanc Sec": "Vins blancs secs issus du Savagnin, élevés traditionnellement sans oxydation."
  },
  vinification: {
    "Récolte": "Vendanges manuelles, raisins surmûris",
    "Pressurage": "Pressurage doux, débourbage naturel",
    "Fermentation": "Fermentation alcoolique en fûts de chêne",
    "Élevage": "6 ans minimum sous voile de levures, sans ouillage",
    "Mise en bouteille": "Clavelin de 62cl (volume historique)"
  },
  statistics: {
    "Surface": "50 hectares",
    "Production": "50,000 bouteilles par an",
    "Nombre de domaines": "15+",
    "Élevage minimum": "6 ans",
    "Garde potentielle": "50+ ans"
  },
  history: "Le vin jaune de Château-Chalon est produit selon des méthodes ancestrales remontant au Moyen Âge. Les moines ont développé la technique d'élevage sous voile de levures. L'appellation Château-Chalon a été créée en 1936, reconnaissant l'excellence de ce terroir unique. Le vin jaune était traditionnellement offert aux rois de France et reste aujourd'hui l'un des vins les plus prestigieux du Jura.",
  foodPairing: "Comté vieux (24-36 mois), foie gras, volaille au vin jaune, poulet de Bresse, morilles, truites du Doubs, noix, amandes, curry, cuisine asiatique. Le vin jaune de Château-Chalon est un vin de méditation, parfait pour les moments de convivialité et les repas gastronomiques."
}); 